import { TimeSheetsPage } from '../../../sections/@time-sheets/TimeSheetPage';
import { TimeSheetsPageContextProvider } from '../../../sections/@time-sheets/context/TimeSheetsPageContext';

export const TimeSheetsPageWrapper = () => (
  <TimeSheetsPageContextProvider>
    <TimeSheetsPage />
  </TimeSheetsPageContextProvider>
);
